import React, { useRef } from "react";
import { useTranslation } from "react-i18next";
import SendText from "../SendText.jsx";
import { ENUM_CHAT_TAB } from "../../../../common/enums.js";
import ShowContainer from "../../../../mui/ShowContainer.jsx";
import SendPlugContainer from "../send_plug_container/SendPlugContainer.jsx";
import OnlyMeMessage from "../../only_me_message/OnlyMeMessage.jsx";
import "./chat-send.scss";

export default function ChatSend({
  onChangeAmount,
  tab,
  skipPlug,
  onSendMes,
  sendPlug,
  placeholder,
  amount,
  setCurrentToken,
}) {
  const { t } = useTranslation();

  const ChatSendRef = useRef(null);
  const tabFree = tab === ENUM_CHAT_TAB.free;

  return (
    <>
      <div className="chat__send" ref={ChatSendRef}>
        <ShowContainer condition={sendPlug}>
          <SendPlugContainer
            tab={tab}
            amount={amount}
            onChangeAmount={onChangeAmount}
            setCurrentToken={setCurrentToken}
            skipPlug={skipPlug}
            tabFree={tabFree}
          />
        </ShowContainer>

        <ShowContainer condition={tabFree}>
          <div className="chat__send__header">
            <OnlyMeMessage />

            <label className="chat__send__label">{t("Your comment")}</label>
          </div>

          <SendText
            onSendMes={onSendMes}
            placeholder={placeholder}
            tab={tab}
            ChatSendRef={ChatSendRef}
          />
        </ShowContainer>
      </div>
    </>
  );
}
